import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { END_POINTS } from '@core/constants';
import {
  ForgotPassword,
  ForgotPasswordModel,
  ResetPasswordParams,
  ResetPasswordResponse,
} from '@core/models';
import { Api } from '@core/services/api.state';
import { ApiService } from '@core/services/api/api.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable()
export class ForgotPasswordService extends Api<ForgotPasswordModel> {
  override endpoint: string;

  constructor(
    apiService: ApiService<ForgotPasswordModel>,
    private httpClient: HttpClient
  ) {
    super(apiService);
  }

  public forgotPassword(
    credentials: ForgotPassword,
    isAdmin: boolean,
    isWelcome = false
  ): Observable<ForgotPasswordModel> {
    this.endpoint = `${environment.apiUrl}${
      isAdmin
        ? END_POINTS.ADMIN.FORGOT_PASSWORD
        : END_POINTS.USER.FORGOT_PASSWORD
    }${isWelcome ? '?isWelcome=true' : ''}`;
    return this.post(credentials);
  }

  public resetPassword(
    credentials: ResetPasswordParams,
    isAdmin: boolean
  ): Observable<ResetPasswordResponse> {
    this.endpoint = `${environment.apiUrl}${
      isAdmin ? END_POINTS.ADMIN.RESET_PASSWORD : END_POINTS.USER.RESET_PASSWORD
    }`;
    return this.httpClient.post<ResetPasswordResponse>(
      this.endpoint,
      credentials
    );
  }
}
